import classNames from 'classnames'
import { Link } from 'gatsby'
import React from 'react'

import { Standard } from '../../logic/catalog'
import { standardToString } from '../../logic/standard'
import IconCircledClear from '../icons/IconCircledClear'

const ProductStandardTag = ({
  standard,
  className,
  highlight,
  href,
  onClick,
  onDelete,
}: {
  standard: Standard
  className?: string
  highlight?: boolean
  href?: string
  onClick?: React.MouseEventHandler
  onDelete?: () => void
}) => {
  const tagContent = (
    <>
      {standardToString(standard)}
      {onDelete && (
        <button className="tag__delete" onClick={onDelete}>
          <IconCircledClear stroke="#666" />
        </button>
      )}
    </>
  )

  return href ? (
    <Link
      className={classNames(
        'tag',
        'tag--clickable',
        { 'tag--highlight': highlight },
        className,
      )}
      onClick={onClick}
      to={href}
      state={{ scrollToOptions: { top: 0 } }}
      rel="nofollow"
    >
      {tagContent}
    </Link>
  ) : (
    <div
      className={classNames('tag', { 'tag--highlight': highlight }, className)}
      onClick={onClick}
    >
      {tagContent}
    </div>
  )
}

export default ProductStandardTag
